<template>
    <div>
        <v-btn color="primary" small @click="deleteNotes()">Delete</v-btn>
    </div>
</template>

<script>
    import Vue from "vue";
    import {createNamespacedHelpers} from "vuex";
    const { mapActions: mapOrderActions } = createNamespacedHelpers(`orders`);

    export default Vue.extend({
        data: () => ({
            note: null,
        }),
        methods: {
            ...mapOrderActions(["deleteKayakoNote"]),
            getDeleteConfirm() {
                return window.confirm('Do you really want to delete this Note?')
            },
            deleteNotes() {
                if(this.getDeleteConfirm())
                {
                    let data = this.params.data;
                    this.deleteKayakoNote(data).then(result => {
                        this.params.clicked(true);
                    });
                }
            },
        },
    });
</script>
